import React, { useCallback, useEffect, useState } from "react";
import * as echarts from "echarts";

const CommonPieChart = ({
  data = [],
  radius = [0, 50],
  containerHeight = 23,
  containerWidth = "100%",
  percentage = false,
  arrows = false,
  marginEnable = true,
  onClick = () => {},
}) => {
  const [clicked, SetClicked] = useState({});

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };


  useEffect(() => {
    if (Object.keys(clicked).length !== 0) {
      onClick(clicked);
      SetClicked({});
    }
  }, [clicked, onClick]);

  useEffect(() => {
    data = data.filter(item => item.value !== 0);
    // Initialize echarts instance
    const chart = echarts.init(document.getElementById("donut-chart"));

    function getDarkBlackCircledNumber(num) {
      switch (num) {
        case 0||'0':
          return "🄋"; // U+24FF
        case 1||'1':
          return "➀"; // U+2776
        case 2||'2':
          return "➁"; // U+2777
        case 3||'3':
          return "➂"; // U+2778
        case 4||'4':
          return "➃"; // U+27710
        case 5||'5':
          return "➄"; // U+277A
        case 6||'6':
          return "➅"; // U+277B
        case 7||'7':
          return "➆"; // U+277C
        case 8||'8':
          return "➇"; // U+277D
        case 9||'9':
          return "➈"; // U+277E
        default:
          return "";
      }
    }

    const dataArray = data.map((item) => ({
      value: parseFloat(item?.value).toFixed(1),  // Ensuring the value is formatted to one decimal place
      name: `${getDarkBlackCircledNumber(Number(item.details.ms_rank))} ${
        capitalizeFirstLetter(item.name) // Apply capitalization here
      } \n${parseFloat(item?.value).toFixed(1)}% ${item.details.ms_delta == 0 ? "▬" : item.details.ms_delta < 0 ? "🡇" : "🡅"}`,
      details: item.details,
      itemStyle: { color: item.color },
      label: {
        formatter: function (params) {
          if (params.name.split(" ")[3] === "▬") {
            return (
              "{a|" +
              params.name.split(" ")[0] +
              "} {b|" +
              params.name.split(" ")[1] +
              "} {c|" +
              params.name.split(" ")[2] +
              "} {f|" +
              params.name.split(" ")[3] +
              "}"
            );
          }else if (params.name.split(" ")[3] === "🡇") {
            return (
              "{a|" +
              params.name.split(" ")[0] +
              "} {b|" +
              params.name.split(" ")[1] +
              "} {c|" +
              params.name.split(" ")[2] +
              "} {d|" +
              params.name.split(" ")[3] +
              "}"
            );
          } else {
            return (
              "{a|" +
              params.name.split(" ")[0] +
              "} {b|" +
              params.name.split(" ")[1] +
              "} {c|" +
              params.name.split(" ")[2] +
              "} {e|" +
              params.name.split(" ")[3] +
              "}"
            );
          }
        },
        rich: {
          a: {
            fontSize: 16, // Font size of the label
            fontWeight: "normal", // Font weight of the label
            color: "black",
          },
          b: {
            fontFamily: "Open Sans", // Set font family to Open Sans
            fontSize: 10, // Font size of the label
            fontWeight: "normal", // Font weight of the label
            color: "black",
          },
          c: {
            fontFamily: "Open Sans", // Set font family to Open Sans
            fontSize: 10, // Font size of the label
            fontWeight: "normal", // Font weight of the label
            color: "black",
          },
          d: {
            fontFamily: "Open Sans", // Set font family to Open Sans
            fontSize: 10, // Font size of the label
            fontWeight: "normal", // Font weight of the label
            color: "red",
          },
          e: {
            fontFamily: "Open Sans", // Set font family to Open Sans
            fontSize: 10, // Font size of the label
            fontWeight: "normal", // Font weight of the label
            color: "green",
          },
          f: {
            fontFamily: "Open Sans", // Set font family to Open Sans
            fontSize: 10, // Font size of the label
            fontWeight: "normal", // Font weight of the label
            color: "#CDCD00",
            marginBottom: "5px"
          },
        },
        backgroundColor: "white",
        shadowBlur: 5,
        shadowColor: "white",
        borderWidth: 3,
        borderColor: "white",
      },
    }));
    // Specify chart configuration and data
    const options = {
      animation: false,
      series: [
        {
          name: "Access From",
          type: "pie",
          radius: ["20%", "50%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 1,
            borderColor: "#fff",
          },
          selectedMode: "single",
          label: {
            minMargin: 15,
            edgeDistance: 10,
            lineHeight: 15,
            backgroundColor: "white",
            shadowBlur: 10,
            shadowColor: "white",
            borderWidth: 2,
            borderColor: "white",
          },
          labelLine: {
            length: 10,
            length2: 10,
            maxSurfaceAngle: 0,
            lineStyle: {
              color: "black", // Change label line color here
            },
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 5,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          data: dataArray,
        },
      ],
    };

    // Set chart options
    chart.setOption(options);

    chart.on("click", function (params) {
      SetClicked(params.data);
      // Reset font weight for all labels
      chart.setOption({
        series: [
          {
            data: dataArray,
          },
        ],
      });
      params.data.label.rich = {
        a: {
          fontFamily: "Open Sans", // Set font family to Open Sans
          fontSize: 16, // Font size of the label
          fontWeight: "bold", // Font weight of the label
          color: "black",
        },
        b: {
          fontFamily: "Open Sans", // Set font family to Open Sans
          fontSize: 10, // Font size of the label
          fontWeight: "bold", // Font weight of the label
          color: "black",
        },
        c: {
          fontFamily: "Open Sans", // Set font family to Open Sans
          fontSize: 10, // Font size of the label
          fontWeight: "bold", // Font weight of the label
          color: "black",
        },
        d: {
          fontFamily: "Open Sans", // Set font family to Open Sans
          fontSize: 10, // Font size of the label
          fontWeight: "bold", // Font weight of the label
          color: "red",
        },
        e: {
          fontFamily: "Open Sans", // Set font family to Open Sans
          fontSize: 10, // Font size of the label
          fontWeight: "bold", // Font weight of the label
          color: "green",
        },
        f: {
          fontFamily: "Open Sans", // Set font family to Open Sans
          fontSize: 10, // Font size of the label
          fontWeight: "bold", // Font weight of the label
         color: "#CDCD00",
         marginBottom: "5px",
        },
      };

      params.data.itemStyle = {
        borderRadius: 1,
        borderColor: "black",
        color: params.data.itemStyle.color,
      };
      params.data.labelLine = {
        show: false,
      };
      const newData = dataArray.map((item) => {
        if (item.name === params.data.name) {
          return params.data;
        } else {
          return item;
        }
      });

      chart.setOption({
        series: [
          {
            data: newData,
          },
        ],
      });
    });

    // Clean up chart instance on unmount
    return () => {
      chart.dispose();
    };
  }, [data]);

  return <div id="donut-chart" style={{ width: "100%", height: "100%" }} />;
};

export default CommonPieChart;
